export const shouldFetchNavlogs = state => {
	return state.auth.token && state.partner.enableNavLog;
};
